import {NotificationManager} from "@systempiloten/react-lib";
import {WarningNotificationTemplate} from "../components/Utils/NotificationTemplates";

export type IntegrationHost = "avid" | "premiere" | null;

// Läuft die App im webview eines Integrations-Plugins? window.uxpHost = Premiere, window.mcapi = Avid.
// In diesem Kontext sind echte Browser-Downloads (anchor.click) + Export architektonisch blockiert — die
// Aktion muss im normalen Browser laufen (Ausnahme: Premiere kann in den Media-Ordner laden).
export function getIntegrationHost(): IntegrationHost {
    const w = window as any;
    if (w.uxpHost) return "premiere";
    if (w.mcapi) return "avid";
    return null;
}

const hostLabel = (h: IntegrationHost): string => (h === "premiere" ? "Premiere" : h === "avid" ? "Avid" : "");

// Toast-Hinweis, dass Download/Export im Plugin nicht geht und im Browser gemacht werden muss.
export function notifyIntegrationBlocked(action: "download" | "export", host: IntegrationHost) {
    const verb = action === "download" ? "Herunterladen" : "Exportieren";
    const what = action === "download" ? "Dateien herunterzuladen" : "zu exportieren";
    NotificationManager.getInstance().push({
        ...WarningNotificationTemplate,
        text: `${verb} ist im ${hostLabel(host)}-Plugin nicht möglich. Bitte öffne die App im Browser, um ${what}.`,
    });
}

// Sicherheitsnetz: Verhindert im Plugin-Kontext, dass die UXP-webview durch einen anchor-Klick von der App
// WEG-navigiert (Download-Links, fremde Origins). Passiert das, bleibt die webview auf einer Fehler-/Blank-
// Seite hängen und es gibt keinen In-webview-Reload → nur Panel-/Premiere-Neustart hilft. Same-origin
// SPA-Navigation (React Router) bleibt unberührt. Einmal beim App-Start aufrufen.
export function installIntegrationNavigationGuard() {
    if (typeof document === "undefined") return;
    document.addEventListener("click", (e) => {
        if (!getIntegrationHost()) return;
        const anchor = (e.target as HTMLElement | null)?.closest?.("a") as HTMLAnchorElement | null;
        if (!anchor) return;
        const href = anchor.getAttribute("href");
        if (!href || href.startsWith("#")) return;
        // Robuste Origin-Prüfung: ein naives startsWith("/") würde protokoll-relative "//fremd.example"
        // (und Look-alike-Hosts wie "https://app.example.com.evil.com") fälschlich als same-origin werten
        // und die webview trotzdem weg-navigieren lassen. new URL(...) löst relative + absolute korrekt auf.
        let sameOrigin = false;
        try {
            sameOrigin = new URL(href, window.location.href).origin === window.location.origin;
        } catch {
            sameOrigin = false; // unparsebare href -> defensiv als fremd behandeln (abfangen).
        }
        // download-Attribut oder fremde Origin → würde die webview weg-navigieren → im Plugin abfangen.
        if (anchor.hasAttribute("download") || !sameOrigin) {
            // Nur die Navigation verhindern — KEIN stopPropagation: dieser Listener läuft am document in der
            // Capture-Phase, React hängt seine Handler am #root; ein stopPropagation hier verschluckte einen
            // echten onClick auf so einem <a>. preventDefault allein stoppt das Weg-Navigieren.
            e.preventDefault();
        }
    }, true);
}
